import { isRejected } from '@reduxjs/toolkit';
import type { Middleware, MiddlewareAPI, UnknownAction } from '@reduxjs/toolkit';

import { warn } from '../logger';

interface ActionPayload extends UnknownAction {
  payload: {
    message: string;
    [k: string]: unknown;
  };
}

const isActionWithMessage = (action: unknown): action is ActionPayload => {
  return !!(action as ActionPayload).payload?.message;
};

export const rtkQueryErrorLogger: Middleware = (_api: MiddlewareAPI) => (next) => (action) => {
  if (!isActionWithMessage(action)) {
    return next(action);
  }

  if (isRejected(action)) {
    warn('api error', { message: action.payload?.message, action });
  }

  return next(action);
};
